function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import tasks from '@/js/tasks';
import data_center_services from '@/apps/chatbots/services/data_center_services';
import XLSX from 'xlsx';
export default {
  data: function data() {
    return {
      PREFIX: 'INCA_dp_',
      PREFIX_ID: 'inca-ai-' + userInfo.domain.split('.')[0] + '-',
      tab: 0,
      edit: false,
      view: false,
      filters: {},
      show_detail: false,
      filter_enabled: true,
      collapse_filter: false,
      files: [],
      pagination_files: {
        total: 0,
        limit: 10,
        offset: 1,
        current: 1
      },
      headers_files: [{
        value: 'name',
        text: 'Nombre',
        width: "30"
      }, {
        value: 'type',
        text: 'Tipo',
        width: "30"
      }, {
        value: 'embedded_column',
        text: 'Columna Principal',
        width: "30"
      }, {
        value: 'chunk_size',
        text: 'Tamaño de vector',
        width: "20"
      }, {
        value: 'actions',
        text: 'Acciones',
        width: "10"
      }],
      qa: [],
      headers_qa: [{
        value: 'question',
        text: 'Pregunta'
      }, {
        value: 'answer',
        text: 'Respuesta'
      }, {
        value: 'actions',
        text: 'Acciones'
      }],
      pagination_qas: {
        total: 0,
        limit: 10,
        offset: 1,
        current: 1
      },
      file_types: [{
        value: 'CHATBOT_PDF',
        text: "PDF"
      }, {
        value: 'CHATBOT_EXCEL',
        text: "Excel"
      }, {
        value: 'CHATBOT_QA',
        text: "Preguntas / Respuestas"
      }],
      data_center: {
        embedding: "text-embedding-3-large",
        embedding_source: "openAI",
        database_service: "qdrant",
        documents_file_flag: false
      },
      bots: [],
      connections: [],
      datastore: [],
      rules: {
        name: [function (v) {
          return !!v || 'El campo es requerido.';
        }, function (v) {
          return v && v.length <= 100 || 'Menor o igual a 100 caracteres.';
        }],
        description: [function (v) {
          return v == "" || v == undefined || v == null || v && v.length <= 1024 || 'Menor o igual a 1024 caracteres.';
        }],
        database_service_id: [function (v) {
          return !!v || 'El campo es requerido.';
        }, function (v) {
          return v && v.length <= 63 || 'Menor o igual a 63 caracteres.';
        }, function (v) {
          return /^[a-z]([a-z0-9-]{0,61}[a-z0-9])?$/.test(v) || 'Solo minúsculas, empieza con una letra, puede contener letras, numero o guiones, debe terminar con una letra o número.';
        }],
        file_index: [function (v) {
          console.log(v);
          if (!v || Array.isArray(v) && v.length === 0) return true;
          var allowedTypes = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"];
          return allowedTypes.includes(v.type) ? true : 'Solo se permiten archivos Excel (.xls, .xlsx).';
        }],
        file_vs: [function (v) {
          return !!v || 'El campo es requerido.';
        }, function (v) {
          return v.size <= 28 * 1024 * 1024 || 'El archivo no debe superar los 28 MB.';
        }],
        qa: [function (v) {
          return !!v || 'El campo es requerido.';
        }, function (v) {
          return v.length <= 5000 || 'El texto no puede superar los 5000 caracteres.';
        }],
        chunk: [function (v) {
          return !!v || 'El campo es requerido.';
        }]
      },
      key_columns: {},
      key_add: 0,
      key_database_service_id: 1,
      storage_type: [{
        "text": "Vectorial",
        "value": "vector"
      }, {
        "text": "Indexado",
        "value": "index"
      }],
      database: [{
        "text": "Qdrant",
        "value": "qdrant"
      }, {
        "text": "Azure AISearch",
        "value": "azure"
      }],
      documents_file: [],
      documents_file_array: [],
      item_modal: {},
      key_modal: 0,
      rows: [],
      headers_rows: [],
      editedRow: {},
      file_row_selected: {},
      rows_query_search: null,
      pagination: {
        limit: 10,
        current: 1,
        total: 0
      },
      key_pagination: 1
    };
  },
  computed: {
    getClassTable: function getClassTable() {
      if (this.filter_enabled) {
        return 'col-md-9 col-sm-12';
      } else {
        return 'col-sm-12';
      }
    },
    filteredFiles: function filteredFiles() {
      return this.files.filter(function (item) {
        return !item.deleted || item.deleted === false;
      });
    },
    filteredQa: function filteredQa() {
      return this.qa.filter(function (item) {
        return !item.deleted || item.deleted === false;
      });
    }
  },
  created: function created() {
    console.log("domain", userInfo);
    this.id = this.$router.currentRoute.params.id;
    console.log(this.id);
    this.mode = this.$route.meta.mode;
    if (this.mode == "edit") this.edit = true;
    if (this.mode == "view") this.view = true;
    if (this.id) {
      this.getDataCenter();
    }
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    formatDate: function formatDate(data) {
      if (data) return data ? data.substring(0, 19).replace("T", " ") : '';
      return "";
    },
    handleFileUpload: function handleFileUpload(item, event) {
      var _this = this;
      console.log(event);
      item.file_type = event.type;
      item.file_size = event.size;
      item.name = event.name;
      if (event.type == "application/pdf") {
        item.type = "CHATBOT_PDF";
      }
      if (item.type == 'CHATBOT_PDF') {
        return;
      }
      item.columns = [];
      item.embedded_column = null;
      var reader = new FileReader();
      reader.onload = function (e) {
        var data = new Uint8Array(e.target.result);
        var workbook = XLSX.read(data, {
          type: 'array'
        });
        console.log("test", workbook);
        var firstSheetName = workbook.SheetNames[0];
        var worksheet = workbook.Sheets[firstSheetName];
        var jsonData = XLSX.utils.sheet_to_json(worksheet, {
          header: 1
        });
        var columns = jsonData[0];
        item.columns = columns;
        console.log('Columnas extraídas:', columns);
        setTimeout(function () {
          _this.key_columns[item.index] = _toConsumableArray(columns);
          _this.key_modal = _this.key_modal + 1;
        }, 250);
      };
      reader.readAsArrayBuffer(item.file);

      /*const reader = new FileReader();
       reader.onload = (event) => {
          const data = event.target.result
          const workbook = XLSX.read(data, { type: 'array' })
          console.log("test", workbook)
          const worksheet = workbook.Sheets[workbook.SheetNames[0]];
          const range = XLSX.utils.decode_range(worksheet['!ref']);
          console.log("range", range)
          const columnHeaders = [];
      
          // Obtener encabezados de columna
          for (let C = range.s.c; C <= range.e.c; ++C) {
              console.log("valores", range.s.c,range.e.c)
              const cell = worksheet[XLSX.utils.encode_cell({ c: C, r: range.s.r })];
              console.log(cell,C)
              columnHeaders.push(cell.v);
          }
          
          // Actualizar las columnas disponibles
          item.columns = columnHeaders;
          setTimeout(() => {
              this.key_columns[item.index] = [...columnHeaders]
          }, 250)
      };
       reader.readAsArrayBuffer(item.file);*/
      console.log(item);
    },
    onValidateForm: function onValidateForm() {
      return true;
    },
    getDataCenter: function getDataCenter() {
      var _this2 = this;
      data_center_services.get(this.id).then(function (response) {
        _this2.data_center = response.data;
        _this2.qa = response.data.qa ? response.data.qa : [];
        _this2.files = response.data.files ? response.data.files : [];
        //this.documents_file= response.data.documents_file
      });
    },
    onSaveDataCenter: function onSaveDataCenter() {
      var _this3 = this;
      if (!this.$refs.form_data_center.validate()) return;
      if (!this.onValidateForm()) return;
      var formData = new FormData();
      var files = [];
      this.files.forEach(function (element) {
        formData.append(element.name, element.file);
        var item = {
          chunk_overlap: element.chunk_overlap,
          chunk_size: element.chunk_size,
          file_type: element.file_type,
          file_size: element.file_size,
          type: element.type,
          name: element.name,
          columns: element.columns,
          embedded_column: element.embedded_column
        };
        if (element.file_id) {
          item.file_id = element.file_id;
        }
        files.push(item);
      });
      var documents_file = [];
      if (this.documents_file) {
        formData.append(this.documents_file.name, this.documents_file);
        this.data_center.documents_file_flag = true;
        var item = {
          name: this.documents_file.name
        };
        documents_file.push(item);
      }
      this.data_center.files = files;
      this.data_center.qa = this.qa;
      this.data_center.documents_file = documents_file;
      formData.append("data", JSON.stringify(this.data_center));
      console.log(this.data_center);
      data_center_services.create(formData).then(function (response) {
        if (response.success) {
          tasks.toast.success("El registro se guardó correctamente.");
          _this3.onCancelar();
        } else {
          if (response.message) {
            tasks.toast.error(response.message);
          } else {
            tasks.toast.error("No se pudo guardar el registro.");
          }
        }
      });
    },
    onUpdateDataCenter: function onUpdateDataCenter() {
      var _this4 = this;
      if (!this.$refs.form_data_center.validate()) return;
      if (!this.onValidateForm()) return;
      var formData = new FormData();
      var files = [];
      this.files.forEach(function (element) {
        formData.append(element.name, element.file);
        var item = _objectSpread({
          chunk_overlap: element.chunk_overlap,
          chunk_size: element.chunk_size,
          file_type: element.file_type,
          file_size: element.file_size,
          type: element.type,
          name: element.name,
          columns: element.columns,
          embedded_column: element.embedded_column
        }, element.hasOwnProperty('deleted') && {
          deleted: element.deleted
        });
        if (element.file_id) {
          item.file_id = element.file_id;
        }
        files.push(item);
      });
      var documents_file = [];
      console.log("primero", this.documents_file);
      if (this.documents_file) {
        console.log("entra a guardar");
        formData.append(this.documents_file.name, this.documents_file);
        this.data_center.documents_file_flag = true;
        var item = {
          name: this.documents_file.name
        };
        documents_file.push(item);
      }
      console.log("actual", this.data_center.documents_file);
      console.log("ok");
      if (this.documents_file.length != 0 && this.data_center.documents_file != 0) {
        this.data_center.actual_documents_file_id = this.data_center.documents_file[0] ? this.data_center.documents_file[0].file_id : '';
      }
      console.log("segundo", documents_file);
      //this.data_center.name = this.PREFIX + this.data_center.name 
      this.data_center.files = files;
      this.data_center.qa = this.qa;
      this.data_center.documents_file = documents_file;
      console.log(this.data_center);
      formData.append("data", JSON.stringify(this.data_center));
      data_center_services.update(this.data_center.datacenter_id, formData).then(function (response) {
        if (response.success) {
          tasks.toast.success("El registro se actualizó correctamente.");
          _this4.onCancelar();
        } else {
          if (response.message) {
            tasks.toast.error(response.message);
          } else {
            tasks.toast.error("No se pudo guardar el registro.");
          }
        }
      });
    },
    onCancelar: function onCancelar() {
      this.$router.push({
        name: 'DataCenter'
      });
    },
    addRowFile: function addRowFile() {
      this.key_add += 1;
      this.key_columns[this.key_add] = [];
      this.files.unshift({
        index: this.key_add,
        chunk_overlap: "40",
        chunk_size: "3000"
      });
    },
    addRowQA: function addRowQA() {
      this.qa.unshift({
        chunk_overlap: "1",
        chunk_size: "6000",
        question: "",
        answer: ""
      });
    },
    onRemoveFile: function onRemoveFile(item) {
      if (item.file_id) {
        item.deleted = true;
        console.log("eliminado logico", this.files);
      } else {
        var index = this.files.findIndex(function (x) {
          return x.name == item.name;
        });
        if (index != -1) {
          //mover a eliminado por tabla
          this.files.splice(index, 1);
        }
      }
    },
    filterDeleted: function filterDeleted(value, search, item) {
      return item.deleted === false || item.deleted === undefined;
    },
    onRemoveQA: function onRemoveQA(item) {
      if (item.qa_id) {
        item.deleted = true;
      } else {
        var index = this.qa.findIndex(function (x) {
          return x == item;
        });
        if (index != -1) {
          this.qa.splice(index, 1);
        }
      }
    },
    idNameLine: function idNameLine(name) {
      if (name.startsWith('-')) {
        name = name.substring(1);
      }
      if (name.endsWith('-')) {
        name = name.slice(0, -1);
      }
      if (name.startsWith('-') || name.endsWith('-')) {
        name = this.idNameLine(name);
      }
      return name;
    },
    onChangeName: function onChangeName(event) {
      if (this.mode != "create") return;
      var name = "" + this.data_center.name;
      name = name.toLowerCase();
      name = name.replace(" ", "-");
      name = name.replace(/[^a-zA-Z0-9]/g, '-');
      name = name.replace("--", "-");
      name = name.replace("--", "-");
      name = name.replace("--", "-");
      if (/^\d/.test(name)) {
        name = name.substring(1);
      }
      if (/^\d/.test(name)) {
        name = name.substring(1);
      }
      if (/^\d/.test(name)) {
        name = name.substring(1);
      }
      name = this.idNameLine(name);
      this.data_center.database_service_id = this.PREFIX_ID + "" + name;
      //console.log(this.profiling.data_scan_id)
      this.key_database_service_id += 1;
      //this.key_form += 1
    },
    downloadExcelTemplate: function downloadExcelTemplate() {
      var data = [{
        "TITULO": '',
        "DESCRIPCIÓN": '',
        "SEGMENTO": '',
        "KEYWORD": '',
        "LINK": ''
      }];
      var ws = XLSX.utils.json_to_sheet(data);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Plantilla Indexación');
      XLSX.writeFile(wb, 'Plantilla_Indexacion.xlsx');
    },
    openDialog: function openDialog(mode, data) {
      this.item_modal = {
        chunk_size: 3000,
        chunk_overlap: 40
      };
      this.$refs.dialog.onOpen();
    },
    addItem: function addItem() {
      console.log(this.item_modal);
      this.key_add += 1;
      this.key_columns[this.key_add] = [];
      this.files.unshift(_objectSpread(_objectSpread({}, this.item_modal), {}, {
        index: this.key_add
        //chunk_overlap: "40",
        //chunk_size: "3000"
      }));
      console.log("files:", this.files);
      this.$refs.dialog.onClose();
    },
    editRows: function editRows(item) {
      console.log(item);
      this.file_row_selected = item;
      this.get_file_rows();
    },
    get_file_rows: function get_file_rows() {
      var _this5 = this;
      data_center_services.get_file_rows(this.file_row_selected.datacenter_id, this.file_row_selected.file_id, this.rows_query_search, this.pagination.limit, this.pagination.current).then(function (response) {
        //response= JSON.parse(response)
        console.log("response rows", _typeof(response));
        if (response.success) {
          if (response.data) {
            if (response.data.length > _this5.pagination.limit - 1) {
              //console.log("has next", response.data.result.length)
              _this5.pagination.next = true;
            } else {
              //console.log("no has next", response.data.result.length)
              _this5.pagination.next = false;
            }
            _this5.pagination.total = response.data.length;
            _this5.key_pagination += 1;
            _this5.rows = response.data;
            if (_this5.rows.length) {
              _this5.headers_rows = Object.keys(_this5.rows[0]).filter(function (key) {
                return key !== "row_id";
              }) // Filtra la clave "row_id"
              .map(function (key) {
                return {
                  text: key.charAt(0).toUpperCase() + key.slice(1),
                  value: key
                };
              });
              _this5.headers_rows.push({
                text: "Acciones",
                value: "actions",
                sortable: false
              });
            }
            _this5.$refs.dialog_edit_file.onOpen();
          } else {
            _this5.pagination.next = false;
            _this5.pagination.total = 0;
            _this5.key_pagination += 1;
          }
        } else {
          if (response.message) {
            tasks.toast.error(response.message);
          } else {
            tasks.toast.error("No se pudo guardar el registro.");
          }
        }
      });
    },
    openEdit: function openEdit(item, field) {
      this.editedRow = _objectSpread({}, item);
      console.log(this.editedRow);
    },
    cancelEdit: function cancelEdit() {
      var _this6 = this;
      var index = this.rows.findIndex(function (row) {
        return row.row === _this6.editedRow.row;
      });
      if (index !== -1) {
        this.rows[index] = _objectSpread({}, this.editedRow);
      }
    },
    saveRow: function saveRow() {
      console.log("Campo guardado temporalmente");
    },
    saveChanges: function saveChanges(item) {
      console.log("Guardando cambios:", item, this.file_row_selected);
      data_center_services.update_row(item.row_id, this.file_row_selected.datacenter_id, this.file_row_selected.file_id, item).then(function (response) {
        if (response.success) {
          tasks.toast.success("El registro se actualizó correctamente.");
        } else {
          if (response.message) {
            tasks.toast.error(response.message);
          } else {
            tasks.toast.error("No se pudo guardar el registro.");
          }
        }
      });
    },
    resetQuery: function resetQuery() {
      this.rows_query_search = null;
      this.pagination.current = 1;
    },
    changePagina: function changePagina() {
      this.get_file_rows();
    }
  }
};